import PortailMedecin from "./PortailMedecin.jsx";
// ===============================
// App.js - VERSION PR2 PORT ROYAL
// ===============================

import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext.jsx";
import DialogProvider from "./ui/DialogProvider.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";
import ProtectedRouteResponsable from "./components/ProtectedRouteResponsable.jsx";
import JuniorCampaignAccess from "./components/JuniorCampaignAccess.jsx";
import MedecinMultisecteurPortalRedirect from "./components/MedecinMultisecteurPortalRedirect.jsx";
import HomeRedirect from "./components/HomeRedirect.jsx";
import ScrollToTop from "./components/ScrollToTop.jsx";

// 🏠 Pages principales
import OngletAccueil from "./OngletAccueil.jsx";
import InterfaceMedecins from "./InterfaceMedecins.jsx";
import InterfaceMedecinsPR1 from "./InterfaceMedecinsPR1.jsx";

// 🆕 Portail générique service
import PortailService from "./PortailService.jsx";

// 🆕 Auth médecins
import AuthHome from "./AuthHome.jsx";
import AuthRegister from "./AuthRegister.jsx";
import AuthActivate from "./AuthActivate.jsx";
import LegacyAuthEntry from "./components/LegacyAuthEntry.jsx";
import AuthForgot from "./AuthForgot.jsx";
import AuthReset from "./AuthReset.jsx";

// Désidérata médecins
import DesiderataPlanningDigestif from "./desiderata_planning_digestif.jsx";
import DesiderataGardePortRoyal from "./desiderata_garde_port_royal.jsx";
import DesiderataGardePortRoyalPR1 from "./desiderata_garde_port_royal_pr1.jsx";
import DesiderataAstreinteThoracique from "./DesiderataAstreinteThoracique.jsx";
import DesiderataPlanningPortRoyal from "./DesiderataPlanningPortRoyal.jsx";

// 👁️ Désidératas activité ophtalmologie
import PlanningEditorOph from "./anesthesie-oph/PlanningEditorOph.jsx";

// 👩‍💼 Interface Responsable
import VieService from "./VieService.jsx";
import OngletRegles from "./OngletRegles.jsx";
import OngletGardes from "./OngletGardes.jsx";
import OngletEquipe from "./OngletEquipe.jsx";
import OngletListesMedecins from "./OngletListesMedecins.jsx";

// Gestion des gardes côté responsable
import OngletGardesBrute from "./OngletGardesBrute.jsx";
import OngletGardesDesiderata from "./OngletGardesDesiderata.jsx";
import OngletListeMedecinsGardes from "./OngletListeMedecinsGardes.jsx";

// ✅ Liste validée : wrappers séparés
import ListeGardeValideeMedecin from "./ListeGardeValideeMedecin.jsx";
import ListeGardeValideeResponsable from "./ListeGardeValideeResponsable.jsx";

// ✅ Interface médecin astreinte thoracique (page intermédiaire)
import InterfaceAstreinteThoracique from "./InterfaceAstreinteThoracique.jsx";

// 📘 Autres contenus
import ReglesService from "./ReglesService.jsx";
import PlanningValide from "./PlanningValide.jsx";

// 🧩 Trames et affichages spécifiques
import TrameMensuelleGarde from "./TrameMensuelleGarde.jsx";

// ⚙️ Configuration des désidérata (RESPONSABLE)
import ConfigDesiderataPR2 from "./ConfigDesiderataPR2.jsx";
import ConfigDesiderataPR1 from "./ConfigDesiderataPR1.jsx";
import ConfigDesiderataAstreinteThoracique from "./ConfigDesiderataAstreinteThoracique.jsx";
import ConfigDesiderataDigestif from "./ConfigDesiderataDigestif.jsx";
import ConfigDesiderataReanimation from "./ConfigDesiderataReanimation.jsx";
import ConfigDesiderataInterne1 from "./ConfigDesiderataInterne1.jsx";
import ConfigDesiderataInterne2 from "./ConfigDesiderataInterne2.jsx";
import ConfigDesiderataInterneDigestif from "./ConfigDesiderataInterneDigestif.jsx";
import ConfigDesiderataInterneRea from "./ConfigDesiderataInterneRea.jsx";
import ConfigDesiderataPlanningPR from "./ConfigDesiderataPlanningPR.jsx";
import OngletPlanningPR from "./OngletPlanningPR.jsx";
import OngletPlanningPRAccesMedecins from "./OngletPlanningPRAccesMedecins.jsx";
import ConfigDesiderataPlanningThoracique from "./ConfigDesiderataPlanningThoracique.jsx";
import OngletPlanningThoracique from "./OngletPlanningThoracique.jsx";
import OngletPlanningThoraciqueAccesMedecins from "./OngletPlanningThoraciqueAccesMedecins.jsx";
import DesiderataPlanningThoracique from "./DesiderataPlanningThoracique.jsx";
import OngletThoraciqueResponsable from "./OngletThoraciqueResponsable.jsx";

function ResponsableStaticRouteRedirect() {
  const location = useLocation();
  React.useEffect(() => {
    window.location.replace(`/responsable/retour-portail.html${location.search || ""}`);
  }, [location.search]);
  return null;
}

function ResponsableOphMultisecteurRedirect() {
  return (
    <Navigate
      to="/multisecteur/responsable/index.html?secteur=sect-oph&lockSecteur=1"
      replace
    />
  );
}

function MultisecteurReactPrefixRedirect() {
  const location = useLocation();
  const targetPath = location.pathname.replace(/^\/multisecteur(?=\/|$)/, "") || "/";
  return <Navigate to={`${targetPath}${location.search || ""}`} replace />;
}

export default function App() {
  const BUILD_TAG = "thoracique-fix-2026-03-09-08-40";
  return (
    <DialogProvider>
      <AuthProvider>
        <Router>
        <ScrollToTop />
        <div data-build-tag={BUILD_TAG} style={{ display: "none" }} />
        <Routes>
          {/* ✅ Route racine : redirection intelligente selon le type d'utilisateur */}
          <Route path="/" element={<HomeRedirect />} />
          <Route path="/multisecteur/auth/*" element={<MultisecteurReactPrefixRedirect />} />
          <Route path="/multisecteur/portail-medecin" element={<MultisecteurReactPrefixRedirect />} />
          <Route path="/multisecteur/responsable/equipe" element={<MultisecteurReactPrefixRedirect />} />
          <Route path="/multisecteur/responsable/vie-service" element={<MultisecteurReactPrefixRedirect />} />
          <Route path="/multisecteur/responsable/gardes" element={<MultisecteurReactPrefixRedirect />} />
          <Route path="/multisecteur/responsable/thoracique" element={<MultisecteurReactPrefixRedirect />} />
          <Route path="/multisecteur/responsable/planning-thoracique" element={<MultisecteurReactPrefixRedirect />} />
          <Route path="/multisecteur/responsable/config-desiderata-planning-thoracique" element={<MultisecteurReactPrefixRedirect />} />
          <Route path="/multisecteur/responsable/planning-thoracique-acces-medecins" element={<MultisecteurReactPrefixRedirect />} />
          <Route path="/multisecteur/responsable/*" element={<MultisecteurReactPrefixRedirect />} />

        {/* 🆕 Portail */}
        <Route path="/portail" element={<PortailService />} />

        {/* 🆕 Auth */}
        <Route path="/auth" element={<LegacyAuthEntry><AuthHome /></LegacyAuthEntry>} />
        <Route path="/auth/register" element={<AuthRegister />} />
        <Route path="/auth/register-interne" element={<AuthRegister mode="junior" />} />
        <Route path="/auth/activate" element={<AuthActivate />} />
        <Route path="/auth/login" element={<LegacyAuthEntry />} />

        {/* Portail médecin après connexion (protégé) */}
        <Route
          path="/portail-medecin"
          element={(<ProtectedRoute><PortailMedecin /></ProtectedRoute>)}
        />

        {/* 🆕 Mot de passe oublié */}
        <Route path="/auth/forgot" element={<AuthForgot />} />
        <Route path="/auth/reset" element={<AuthReset />} />

        {/* 🔐 Ancienne page d'accueil conservée */}
        <Route path="/pr2-accueil" element={<OngletAccueil />} />

        {/* 👨‍⚕️ Interface Médecins - Accessible sans authentification (pour tests) */}
        <Route path="/interface-medecins" element={(<ProtectedRoute><InterfaceMedecins /></ProtectedRoute>)} />
        <Route path="/interface-medecins-pr1" element={(<ProtectedRoute><InterfaceMedecinsPR1 /></ProtectedRoute>)} />
        <Route path="/interface-astreinte-thoracique" element={(<ProtectedRoute><InterfaceAstreinteThoracique /></ProtectedRoute>)} />
        <Route path="/medecin" element={(<ProtectedRoute><InterfaceMedecins /></ProtectedRoute>)} />
        {/* HTML statique multisecteur : évite page blanche si le fallback SPA intercepte /medecin/index.html */}
        <Route path="/medecin/index.html" element={<MedecinMultisecteurPortalRedirect />} />

        {/* 👩‍💼 Interface Responsable - Protégée (rôle responsable requis) */}
        <Route path="/responsable" element={<ResponsableStaticRouteRedirect />} />
        <Route path="/responsable/index.html" element={<ResponsableStaticRouteRedirect />} />
        <Route path="/responsable/regles" element={(<ProtectedRouteResponsable><OngletRegles /></ProtectedRouteResponsable>)} />
        <Route path="/responsable/gardes" element={(<ProtectedRouteResponsable><OngletGardes /></ProtectedRouteResponsable>)} />
        <Route path="/responsable/gardes-liste-medecins" element={(<ProtectedRouteResponsable><OngletListeMedecinsGardes /></ProtectedRouteResponsable>)} />
        <Route path="/responsable/thoracique" element={(<ProtectedRouteResponsable><OngletThoraciqueResponsable /></ProtectedRouteResponsable>)} />
        <Route path="/responsable/planning" element={<Navigate to="/responsable/planning-pr" replace />} />
        <Route path="/responsable/planning-editor/:annee?/:mois?" element={<Navigate to="/responsable/planning-pr" replace />} />
        <Route path="/responsable/equipe" element={(<ProtectedRouteResponsable><OngletEquipe /></ProtectedRouteResponsable>)} />
        <Route path="/responsable/vie-service" element={(<ProtectedRouteResponsable><VieService /></ProtectedRouteResponsable>)} />
        <Route path="/responsable/listes-medecins" element={(<ProtectedRouteResponsable><OngletListesMedecins /></ProtectedRouteResponsable>)} />

        {/* 👁️ Interface Responsable – Ophtalmologie */}
        <Route path="/responsable/oph" element={(<ProtectedRouteResponsable><ResponsableOphMultisecteurRedirect /></ProtectedRouteResponsable>)} />
        <Route path="/responsable/oph-liste-medecins" element={<ResponsableOphMultisecteurRedirect />} />
        <Route path="/responsable/oph-desiderata" element={<ResponsableOphMultisecteurRedirect />} />
        <Route path="/responsable/oph-planning/:annee/:mois/:semaine" element={(<ProtectedRouteResponsable><PlanningEditorOph /></ProtectedRouteResponsable>)} />
        <Route path="/responsable/oph-planning" element={(<ProtectedRouteResponsable><PlanningEditorOph /></ProtectedRouteResponsable>)} />

        {/* ⚙️ Configuration des désidérata */}
        <Route
          path="/responsable/config-desiderata"
          element={(<ProtectedRouteResponsable><ConfigDesiderataPR2 /></ProtectedRouteResponsable>)}
        />
        <Route
          path="/responsable/config-desiderata-pr1"
          element={(<ProtectedRouteResponsable><ConfigDesiderataPR1 /></ProtectedRouteResponsable>)}
        />
        <Route
          path="/responsable/config-desiderata-oph"
          element={<ResponsableOphMultisecteurRedirect />}
        />
        <Route
          path="/responsable/config-desiderata-orthopedie"
          element={<ProtectedRouteResponsable><ConfigDesiderataAstreinteThoracique orthopedie /></ProtectedRouteResponsable>}
        />
        <Route
          path="/responsable/config-desiderata-astreinte-thoracique"
          element={(<ProtectedRouteResponsable><ConfigDesiderataAstreinteThoracique /></ProtectedRouteResponsable>)}
        />
        <Route
          path="/responsable/config-desiderata-digestif"
          element={(<ProtectedRouteResponsable><ConfigDesiderataDigestif /></ProtectedRouteResponsable>)}
        />
        <Route
          path="/responsable/config-desiderata-reanimation"
          element={(<ProtectedRouteResponsable><ConfigDesiderataReanimation /></ProtectedRouteResponsable>)}
        />
        <Route
          path="/responsable/config-desiderata-interne1"
          element={(<ProtectedRouteResponsable><JuniorCampaignAccess type="INTERNE1"><ConfigDesiderataInterne1 /></JuniorCampaignAccess></ProtectedRouteResponsable>)}
        />
        <Route
          path="/responsable/config-desiderata-interne2"
          element={(<ProtectedRouteResponsable><JuniorCampaignAccess type="INTERNE2"><ConfigDesiderataInterne2 /></JuniorCampaignAccess></ProtectedRouteResponsable>)}
        />
        <Route
          path="/responsable/config-desiderata-interne-digestif"
          element={(<ProtectedRouteResponsable><JuniorCampaignAccess type="INTERNE_DIGESTIF"><ConfigDesiderataInterneDigestif /></JuniorCampaignAccess></ProtectedRouteResponsable>)}
        />
        <Route
          path="/responsable/config-desiderata-interne-rea"
          element={(<ProtectedRouteResponsable><JuniorCampaignAccess type="INTERNE_REA"><ConfigDesiderataInterneRea /></JuniorCampaignAccess></ProtectedRouteResponsable>)}
        />
        <Route
          path="/responsable/config-desiderata-planning-pr"
          element={(<ProtectedRouteResponsable><ConfigDesiderataPlanningPR /></ProtectedRouteResponsable>)}
        />
        <Route
          path="/responsable/planning-pr"
          element={(<ProtectedRouteResponsable><OngletPlanningPR /></ProtectedRouteResponsable>)}
        />
        <Route
          path="/responsable/planning-pr-acces-medecins"
          element={(<ProtectedRouteResponsable><OngletPlanningPRAccesMedecins /></ProtectedRouteResponsable>)}
        />
        <Route
          path="/responsable/config-desiderata-planning-thoracique"
          element={(<ProtectedRouteResponsable><ConfigDesiderataPlanningThoracique /></ProtectedRouteResponsable>)}
        />
        <Route
          path="/responsable/planning-thoracique"
          element={(<ProtectedRouteResponsable><OngletPlanningThoracique /></ProtectedRouteResponsable>)}
        />
        <Route
          path="/responsable/planning-thoracique-acces-medecins"
          element={(<ProtectedRouteResponsable><OngletPlanningThoraciqueAccesMedecins /></ProtectedRouteResponsable>)}
        />

        {/* ✅ Gestion détaillée des gardes */}
        <Route
          path="/responsable/gardes-brute"
          element={(<ProtectedRouteResponsable><OngletGardesBrute /></ProtectedRouteResponsable>)}
        />
        <Route
          path="/responsable/gardes-desiderata"
          element={(<ProtectedRouteResponsable><OngletGardesDesiderata /></ProtectedRouteResponsable>)}
        />

        {/* ✅ Liste validée — RESPONSABLE */}
        <Route
          path="/responsable/gardes-valide"
          element={(<ProtectedRouteResponsable><ListeGardeValideeResponsable /></ProtectedRouteResponsable>)}
        />

        {/* ✅ Liste validée — MEDECIN (lecture seule) */}
        <Route
          path="/liste-garde-validee"
          element={(<ProtectedRoute><ListeGardeValideeMedecin /></ProtectedRoute>)}
        />

        {/* 🌟 Planning validé */}
        <Route path="/planning-valide" element={<PlanningValide mois="2026-02" />} />
        <Route
          path="/planning-valide-test"
          element={<PlanningValide mois="2026-02" />}
        />

        {/* Désidérata */}
        <Route
          path="/desiderata-planning-digestif"
          element={<DesiderataPlanningDigestif />}
        />
        <Route
          path="/desiderata-garde-port-royal"
          element={(<ProtectedRoute><DesiderataGardePortRoyal /></ProtectedRoute>)}
        />
        <Route
          path="/desiderata-garde-reanimation"
          element={(<ProtectedRoute><DesiderataGardePortRoyal gardeType="REANIMATION" /></ProtectedRoute>)}
        />
        <Route
          path="/desiderata-garde-port-royal-pr1"
          element={(<ProtectedRoute><DesiderataGardePortRoyalPR1 /></ProtectedRoute>)}
        />

        {/* 👁️ Désidératas activité ophtalmologie */}
        <Route
          path="/desiderata-planning-port-royal"
          element={(<ProtectedRoute><DesiderataPlanningPortRoyal /></ProtectedRoute>)}
        />
        <Route
          path="/desiderata-activite-oph"
          element={<Navigate to="/portail-medecin" replace />}
        />

        {/* 🫁 Désidératas astreinte thoracique */}
        <Route
          path="/desiderata-astreinte-thoracique"
          element={(<ProtectedRoute><DesiderataAstreinteThoracique /></ProtectedRoute>)}
        />
        <Route
          path="/desiderata-planning-thoracique"
          element={(<ProtectedRoute><DesiderataPlanningThoracique /></ProtectedRoute>)}
        />

        {/* 🧾 Vue mensuelle */}
        <Route path="/trame-mensuelle" element={<TrameMensuelleGarde />} />

        {/* 📘 Divers */}
        <Route path="/regles-service" element={<ReglesService />} />
        </Routes>
        </Router>
      </AuthProvider>
    </DialogProvider>
  );
}
